module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/schedule_06-7a06485548c0748c2b1a1c31e6d8b4ca.jpg";